import React, { FC } from 'react';
import { Content, Row, Title } from './styles';

export interface FormRowProps {
    title: string;
}

const FormRow: FC<FormRowProps> = ({ title, children }) => {
    return (
        <Row>
            <Title>{title}</Title>
            <Content>{children}</Content>
        </Row>
    );
};

export default FormRow;
